import { IState } from 'shared/store';

import { isFromBuilderSelector } from '../offerData/offer/isFromBuilder';

export function selectCallButtonText(state: IState): string {
  const isFromBuilder = isFromBuilderSelector(state);

  return isFromBuilder ? 'Контакты застройщика' : 'Показать телефон';
}
